import { getEntityBadgeClasses, getEntityBadgeLabel, handleInteractiveKeyDown } from './cardUtils';

const EntityCard = ({
  entity,
  onClick,
  onEdit,
  onView,
  onManage,
  showActions = true,
  compact = false,
  showEntityBadge = true,
}) => {
  const interactive = typeof onClick === 'function';
  const entityType = entity?.entityType || entity?.type;

  return (
    <article
      className={`card common-entity-card ${interactive ? 'common-entity-card--interactive' : ''} ${compact ? 'common-entity-card--compact' : ''}`}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={() => onClick?.(entity)}
      onKeyDown={(event) => handleInteractiveKeyDown(event, () => onClick?.(entity))}
    >
      <div className="card-body common-entity-card__body">
        <div className="d-flex justify-content-between align-items-start gap-2">
          <h3 className="h6 mb-0 common-entity-card__title">{entity?.name || 'Untitled entity'}</h3>
          <span className={`badge ${entity?.isActive === false ? 'bg-secondary-subtle text-secondary-emphasis' : 'bg-success-subtle text-success-emphasis'}`}>
            {entity?.isActive === false ? 'Archived' : 'Active'}
          </span>
        </div>

        {showEntityBadge ? <span className={`badge ${getEntityBadgeClasses(entityType)}`}>{getEntityBadgeLabel(entityType)}</span> : null}
        <p className="common-entity-card__meta mb-0">{entity?.description || entity?.location || 'No additional details'}</p>

        {showActions ? (
          <div className="common-entity-card__actions">
            {onView ? <button type="button" className="btn btn-sm btn-outline-primary" onClick={(e) => { e.stopPropagation(); onView(entity); }}>View</button> : null}
            {onManage ? <button type="button" className="btn btn-sm btn-primary" onClick={(e) => { e.stopPropagation(); onManage(entity); }}>Manage</button> : null}
            {onEdit ? <button type="button" className="btn btn-sm btn-outline-secondary" onClick={(e) => { e.stopPropagation(); onEdit(entity); }}>Edit</button> : null}
          </div>
        ) : null}
      </div>
    </article>
  );
};

export default EntityCard;
